import React from 'react'
import {connect} from 'react-redux'
import {Form, actions,} from 'react-redux-form'
import {Row, Col, Button} from 'react-bootstrap'
import RequiredInput from '../../../../common/form/elements/required-input'
import ArrowButton from '../../../../common/button-arrow'
import {saveCategory, updateCategory} from '../../../../../actions/news'

const EditCategoryForm = ({dispatch, category, formValid}) => {

  const onSubmit = (payLoad) => {
    if (category.id) {
      dispatch(actions.submitFields('deep.admin_news.category', updateCategory(category.id, payLoad)));
    } else {
      dispatch(actions.submitFields('deep.admin_news.category', saveCategory(payLoad)));
    }
  };

  return (
    <Form model="deep.admin_news.category" onSubmit={onSubmit}>
      <Row>
        <Col lg={12}>
          <RequiredInput label="Name"
                         placeholder="Name"
                         model='.name'
                         controlId='name'/>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ArrowButton color="grey"
                       className="pull-right"
                       disabled={!formValid}>Save</ArrowButton>
        </Col>
      </Row>
    </Form>
  )
};

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.admin_news.category.$form.valid
  };
};

export default connect(mapStateToProps)(EditCategoryForm);



// WEBPACK FOOTER //
// ./src/components/admin/news/categories/edit/category-edit-form.jsx